import React from 'react';
import { cx } from '../cx';

// D-09 §15.13 — Search (.search > .si + input + .sx 지우기)
// 'width' 는 네이티브 input 속성(string|number)을 가리고 우리 폭 정책 유니온으로 재정의한다
// (input 의 width 속성은 img/canvas 전용이라 의미가 없다).
export interface SearchProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value' | 'size' | 'width'> {
  value: string;
  onChange: (value: string) => void;
  onClear?: () => void;
  error?: string;
  size?: 'sm' | 'md' | 'lg';
  /**
   * 폭 정책 (D-09 §15.13). Input(§15.2)의 `width` 와 같은 유니온이지만 **기본값이 다르다** —
   * 검색은 툴바·패널에서 남는 폭을 채우는 게 기본이라 `fill` 이다.
   *   fill(기본) 부모의 남는 폭 차지 / default 320px 상한 / auto 내용폭
   * `SearchCombo` 내부에서는 조합이 폭을 소유하므로 이 prop 이 적용되지 않는다.
   */
  width?: 'fill' | 'default' | 'auto';
}

export function Search({ value, onChange, onClear, error, size = 'md', width = 'fill', className = '', disabled, ...props }: SearchProps) {
  return (
    <div className={cx('search', size !== 'md' && `search-${size}`, width !== 'default' && `search-${width}`, error && 'error', className)}>
      <span className="si" aria-hidden="true">
        {/* Figma 디자인 벡터 — 돋보기 */}
        <svg width="16" height="16" viewBox="9 10 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.3333 22.6667C19.2789 22.6667 21.6667 20.2789 21.6667 17.3333C21.6667 14.3878 19.2789 12 16.3333 12C13.3878 12 11 14.3878 11 17.3333C11 20.2789 13.3878 22.6667 16.3333 22.6667Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M23 24L20.1333 21.1333" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
      <input value={value} onChange={(e) => onChange(e.target.value)} disabled={disabled} {...props} />
      {value && !disabled && (
        <button
          type="button"
          className="sx"
          aria-label="지우기"
          onClick={() => {
            onChange('');
            onClear?.();
          }}
        >
          {/* Figma 디자인 벡터 — 클리어(×) */}
          <svg width="14" height="14" viewBox="223 13 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M232 14L224 22M224 14L232 22" stroke="currentColor" strokeLinecap="round" />
          </svg>
        </button>
      )}
      {error && <span className="help">{error}</span>}
    </div>
  );
}
